export const aboutMe = [
    {
        id: 1,
        title: 'About Me',
        description: "Dr. Christopher Pecsok graduated cum laude from Logan University of Chiropractic in Chesterfield, Missouri, and possesses nearly 35 years of experience in promoting healing, health, and wellness through Network Spinal Analysis. This approach employs a broad range of force, from a light touch to a stronger, more traditional, structural chiropractic adjustment. This allows for a customizable plan and approach to appropriately meet the needs of the individual patient.",
        image: '/images/chrisheadshot.JPG',
        infobox: '',
    }
];
